import React from 'react';
import { 
  Show,
  UrlField,
  DateField,
  EditButton,
  DeleteButton,
  TopToolbar
} from 'react-admin';
import { makeStyles, Card, CardContent, Typography, Divider, Box } from '@material-ui/core';
import QrCodePreview from './qrCodePreview';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  details: {
    flex: 1,
    marginRight: 0,
    [theme.breakpoints.up('md')]: {
      marginRight: theme.spacing(2),
    },
  },
  preview: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '350px',
    },
  },
  field: {
    marginBottom: theme.spacing(2),
  },
  fieldLabel: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(0.5),
  },
  fieldValue: {
    fontSize: '1rem',
    wordBreak: 'break-all',
  },
  logicCard: {
    marginTop: theme.spacing(3),
    backgroundColor: '#f9f9f9',
    borderRadius: theme.shape.borderRadius,
  },
  divider: {
    margin: theme.spacing(3, 0),
  },
  actions: {
    marginBottom: theme.spacing(2),
    '& button': {
      marginRight: theme.spacing(1),
    }
  }
}));

const QRCodeShowActions = ({ basePath, data, resource }) => {
  const classes = useStyles();

  return (
    <TopToolbar className={classes.actions}>
      <EditButton basePath={basePath} record={data} />
      <DeleteButton basePath={basePath} record={data} />
    </TopToolbar>
  );
};

const QrCodeShow = (props) => {
  const classes = useStyles();
  return (
    <Show 
      {...props} 
      title="QR Code Details" 
      actions={<QRCodeShowActions />}
    >
      <div className={classes.root}>
        <Card className={classes.details}>
          <CardContent>
            <Box className={classes.field}>
              <Typography className={classes.fieldLabel}>QR Code Hash URL</Typography>
              <Typography className={classes.fieldValue}>
                <UrlField source="url" target="_blank" />
              </Typography>
            </Box>
            
            <Box className={classes.field}>
              <Typography className={classes.fieldLabel}>Created At</Typography>
              <Typography className={classes.fieldValue}>
                <DateField source="created_at" showTime />
              </Typography>
            </Box>
            <Divider className={classes.divider} />
            <Typography variant="h6" color="primary" gutterBottom>
              URL for redirects by platforms
            </Typography>
            <Box className={classes.field}>
              <Typography className={classes.fieldLabel}>Web URL</Typography>
              <Typography className={classes.fieldValue}>
                <UrlField source="logic.logic_web" target="_blank" />
              </Typography>
              <Typography className={classes.fieldLabel}>Android URL</Typography>
              <Typography className={classes.fieldValue}>
                <UrlField source="logic.logic_android" target="_blank" />
              </Typography>
              <Typography className={classes.fieldLabel}>iOs URL</Typography>
              <Typography className={classes.fieldValue}>
                <UrlField source="logic.logic_ios" target="_blank" />
              </Typography>
            </Box>
          </CardContent>
        </Card>
        <QrCodePreview />
      </div>
    </Show>
  );
};

export default QrCodeShow;